'use client';

import React from 'react';
import Link from 'next/link';
import { useParams, usePathname } from 'next/navigation';
import Divider from '@mui/material/Divider';
import { SITEMAP_TABS } from '@/constants/sitemap';
import { useBodyClassName } from '@/utils/hooks/useBodyClassName';
import styles from './styles.module.scss';

const PageFrame = (props: { children: React.ReactNode }) => {
  const { children } = props;
  const pathname = usePathname();
  const params = useParams() || null;
  const fullParams = params ? Object.values(params).join('/') : '';

  useBodyClassName('bg-web-grey-350');

  return (
    <div className={`py-9 px-32 ${styles.sitemap}`}>
      <div className={`bg-white px-8 py-6 ${styles.sitemapHead}`}>
        <ul className="text-lg flex flex-row">
          {SITEMAP_TABS.map(({ path, title }) => (
            <li
              key={path}
              className={
                (
                  fullParams
                    ? pathname?.includes(path + fullParams)
                    : pathname === path
                )
                  ? 'text-web-blue-500'
                  : ''
              }
            >
              <Link href={path}>{title}</Link>
            </li>
          ))}
        </ul>
      </div>
      <Divider />
      {children}
    </div>
  );
};

export default PageFrame;
